import {
  FloatingServiceMenu,
  Footer,
  Header,
  Page,
  PageTransition,
  pickSeoProps,
} from '@components/Page'
import { TudorLandingPageBanner } from '@components/_tudor/Banner'
import { TudorLandingPageCheckerboard } from '@components/_tudor/Checkerboard'
import { TudorLandingPageHero } from '@components/_tudor/Hero'
import { TudorLandingPageHistory } from '@components/_tudor/History'
import { TudorLandingPageWatchmaking } from '@components/_tudor/Watchmaking'
import { buildLanguageAlternateNavigation } from '@lib/build-language-alternates'
import { getServerSideTranslations } from '@lib/get-server-side-translations'
import { SingleItemResponse, getPageByCodename } from '@lib/kontent'
import { TudorCheckerboardItem } from '@lib/kontent/models/TudorCheckerboardItem'
import { TudorLandingpage } from '@lib/kontent/models/TudorLandingpage'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'

type AboutTudorProps = SingleItemResponse<TudorLandingpage>

const AboutTudor: NextPage<AboutTudorProps> = ({ item, modular_content }) => {
  const router = useRouter()
  const checkerboardItems = item.elements.untitled_linked_items.value.map(
    (key) => modular_content[key].elements,
  ) as TudorCheckerboardItem[]

  return (
    <Page
      {...pickSeoProps(item.elements)}
      languageAlternates={buildLanguageAlternateNavigation(router.locales, 'about-tudor')}
    >
      <FloatingServiceMenu />
      <Header />
      <PageTransition>
        <TudorLandingPageHero
          title={item.elements.hero_title.value}
          preTitle={item.elements.hero_pretitle.value}
          description={item.elements.hero_description.value}
          image={item.elements.hero_image}
        />
        <TudorLandingPageHistory
          title={item.elements.history_title.value}
          preTitle={item.elements.history_pretitle.value}
          description={item.elements.history_description.value}
          image={item.elements.history_image}
        />
        <TudorLandingPageWatchmaking
          title={item.elements.watchmaking_pretitletitle.value}
          preTitle={item.elements.watchmaking_pretitle.value}
          description={item.elements.watchmaking_description.value}
          videoId={item.elements.watchmaking_youtube_video_id.value}
        />
        <TudorLandingPageCheckerboard items={checkerboardItems} />
        <TudorLandingPageBanner
          title={item.elements.prefooter_title.value}
          image={item.elements.prefooter_background_image}
        />
        <Footer />
      </PageTransition>
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale, preview }) => {
  try {
    const content = await getPageByCodename<TudorLandingpage>({
      codename: 'tudor___landingpage',
      lang: locale as string,
      preview,
    })

    return {
      props: {
        ...content,
        ...(await getServerSideTranslations(locale as string)),
      },
    }
  } catch (error) {
    throw error
  }
}

export default AboutTudor
